import { useSuspenseQuery } from '@tanstack/react-query'
import { createFileRoute } from '@tanstack/react-router'
import { AccountTemplatesPanel } from '@/components/accounts/AccountTemplatesPanel'
import {
  accountQuery,
  reportTemplatesQuery,
  reportsOverviewQuery,
  subaccountsQuery,
} from '@/lib/queries'

/**
 * A client workspace's Templates page — the same panel the account route renders, at a client-scoped
 * URL. Templates are account-owned and clients inherit them, so the content is the account's set;
 * what this route buys is CONTEXT: the sidebar stays the client's, the switcher keeps reading
 * "Account · Client", and navigating between the client's surfaces never bounces through account
 * URLs (the jitter this parity work removes).
 */
export const Route = createFileRoute(
  '/app/accounts/$accountId_/subaccounts/$subaccountId/templates',
)({
  loader: ({ context, params }) =>
    Promise.all([
      context.queryClient.ensureQueryData(accountQuery(params.accountId)),
      context.queryClient.ensureQueryData(reportTemplatesQuery(params.accountId)),
      context.queryClient.ensureQueryData(reportsOverviewQuery),
      context.queryClient.ensureQueryData(subaccountsQuery(params.accountId)),
    ]),
  component: ClientTemplatesPage,
})

function ClientTemplatesPage() {
  const { accountId, subaccountId } = Route.useParams()
  const { data: subsData } = useSuspenseQuery(subaccountsQuery(accountId))
  const client = subsData.subaccounts.find((sub) => sub.id === subaccountId)
  return <AccountTemplatesPanel accountId={accountId} clientName={client?.name ?? 'this client'} />
}
